import React from 'react';
import Conditional from '../../common/conditional';

import { concatClassNames, formatTimeWithRelativeStamp } from '../../../utils/utilities';
import { ProgressComment, User } from '../../../utils/models';
import { getCurrentUser } from '../../../services/authService';

import classNames from './style.module.scss';

interface ProgressCommentProps {
	comments: ProgressComment[];
	onPageClick: (page: number) => void;
}

const ProgressCommentTrail: React.FC<ProgressCommentProps> = ({ comments = [], onPageClick }) => {
	const user = getCurrentUser() as User;

	return (
		<Conditional isVisible={comments.length > 0}>
			<div className="divider my-4"></div>

			<div className={classNames.projectCommentTrail}>
				{comments.map((comment, index) => {
					const isMyComment: boolean = user.id === comment.commentById;

					return (
						<React.Fragment key={comment.commentDate}>
							<div className={concatClassNames(['d-flex',isMyComment ? 'justify-content-end' : 'justify-content-start'])}>
								<div className={concatClassNames([classNames.projectCommentTrailItem,isMyComment ? classNames.projectCommentTrailItemMe : '' ])}>
									<h3 className={classNames.projectCommentTrailItemTitle}>
										<i className="bi bi-chat-dots"></i>
										{comment.title}
									</h3>

									<p>{comment.body}</p>

									<div className="d-flex justify-content-between">
										<div className="d-flex justify-content-center align-items-center">
											<div className={concatClassNames([classNames.projectCommentTrailItemTime, classNames.projectCommentTrailItemTimeLight])}>
												<i className="bi bi-person-circle"></i>
												<span>{comment.commentByName}</span>
											</div>
											<button className={concatClassNames([classNames.projectCommentTrailItemTime, classNames.projectCommentTrailItemTimePage])} onClick={() => onPageClick(comment.pageNumber)}>
												Page #{comment.pageNumber}
											</button>
										</div>

										<div className={classNames.projectCommentTrailItemTime}>
											<i className="bi bi-clock-history"></i>
											<span>{formatTimeWithRelativeStamp(comment.commentDate)}</span>
										</div>
									</div>
								</div>
							</div>

							<Conditional isVisible={index !== (comments.length - 1)}>
								<div className="divider my-4"></div>
							</Conditional>
						</React.Fragment>
					);
				})}
			</div>
		</Conditional>
	);
};

export default ProgressCommentTrail;
